import Box from '@mui/material/Box'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import Header from 'components/header/Header'
import { setShowAppBar } from 'slices/appbar/appbarSlice'

import type { SxProps, Theme } from '@mui/material/styles'

export const MAIN_HEADER_HEIGHT = 56

export type NavbarWrapperProps = {
  children?: React.ReactNode
  sx?: SxProps<Theme>
  className?: string
  innerSx?: SxProps<Theme>
}

const NavbarWrapper: React.FC<NavbarWrapperProps> = ({ children, sx, className = '', innerSx }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setShowAppBar(false))
    return () => {
      dispatch(setShowAppBar(true))
    }
  }, [dispatch])

  return (
    <Box className={className} display="flex" flexDirection="column" height="100vh" sx={sx} width="100%">
      <Box height={MAIN_HEADER_HEIGHT}>
        <Header />
      </Box>
      <Box flex={1} sx={innerSx}>
        {children}
      </Box>
    </Box>
  )
}

export default NavbarWrapper
